var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildLegend, buildTooltip, mergePieSettings } from "./shared";
function buildPieSeries(ctx) {
    var _a, _b, _c, _d, _e;
    var data = ctx.data, settings = ctx.settings;
    var mergedSettings = mergePieSettings(settings);
    var radius = (_b = (_a = data.radius) !== null && _a !== void 0 ? _a : mergedSettings.radius) !== null && _b !== void 0 ? _b : ["40%", "70%"];
    var roseType = (_c = data.roseType) !== null && _c !== void 0 ? _c : mergedSettings.roseType;
    var showLabels = mergedSettings.showLabels !== false;
    var labelContent = (_d = mergedSettings.labelContent) !== null && _d !== void 0 ? _d : "name";
    var sliceGap = (_e = mergedSettings.sliceGap) !== null && _e !== void 0 ? _e : 0;
    var formatterFromSetting = function (params) {
        switch (labelContent) {
            case "value":
                return "".concat(params.value);
            case "percent":
                return "".concat(params.percent, "%");
            case "nameValue":
                return "".concat(params.name, ": ").concat(params.value);
            case "namePercent":
                return "".concat(params.name, ": ").concat(params.percent, "%");
            case "nameValuePercent":
                return "".concat(params.name, ": ").concat(params.value, " (").concat(params.percent, "%)");
            case "name":
            default:
                return params.name;
        }
    };
    var labelFormatter = data.labelFormatter
        ? function (params) {
            var _a;
            var datum = data.items.find(function (item) { return item.name === params.name; });
            return datum ? (_a = data.labelFormatter) === null || _a === void 0 ? void 0 : _a.call(data, datum) : formatterFromSetting(params);
        }
        : formatterFromSetting;
    var labelConfig = showLabels
        ? { show: true, formatter: labelFormatter }
        : { show: false };
    var labelLineConfig = showLabels && mergedSettings.labelLine !== false
        ? { show: true, smooth: true }
        : { show: false };
    var itemStyle = {};
    if (typeof mergedSettings.cornerRadius === "number" &&
        mergedSettings.cornerRadius > 0) {
        itemStyle.borderRadius = mergedSettings.cornerRadius;
    }
    if (sliceGap > 0) {
        itemStyle.borderWidth = sliceGap;
        itemStyle.borderColor = "#fff";
        itemStyle.borderJoin = "round";
    }
    return {
        type: "pie",
        radius: radius,
        roseType: roseType,
        data: data.items.map(function (item) { return (__assign(__assign({}, item), { name: item.name, value: item.value, itemStyle: item.color ? { color: item.color } : undefined })); }),
        label: labelConfig,
        labelLine: labelLineConfig,
        hoverOffset: mergedSettings.explode ? 16 : 6,
        selectedOffset: mergedSettings.explode ? 10 : 0,
        itemStyle: Object.keys(itemStyle).length > 0 ? itemStyle : undefined,
    };
}
var pieChartAdapter = {
    type: "pie",
    buildOption: function (ctx) {
        var mergedSettings = mergePieSettings(ctx.settings);
        var option = {
            tooltip: buildTooltip(ctx.data.tooltip, mergedSettings.tooltip),
            legend: buildLegend(ctx.data.legend, mergedSettings.legend),
            series: [buildPieSeries(ctx)],
        };
        return option;
    },
    getDefaultSettings: function () { return ({
        legend: { show: true, position: "right" },
        tooltip: { enable: true, trigger: "item" },
        radius: ["40%", "70%"],
        showLabels: true,
        labelLine: true,
        explode: false,
        cornerRadius: 0,
        labelContent: "name",
        sliceGap: 0,
    }); },
};
export default pieChartAdapter;
